module.exports = __webpack_public_path__ + "img/pleasure-icon-6.9830329d.svg";